import LegalPage from './LegalPage'

export default function TermsOfService() {
  return (
    <LegalPage title="Terms of Service">
      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing and using this website, you accept and agree to be bound by the terms 
        and provision of this agreement.
      </p>

      <h2>2. Services</h2>
      <p>
        Evoaxy Solutions provides software development, web development, mobile development, 
        and related consulting services. We reserve the right to modify or discontinue any 
        service at any time.
      </p>

      <h2>3. User Responsibilities</h2>
      <p>
        You agree to:
      </p>
      <ul>
        <li>Provide accurate and complete information</li>
        <li>Maintain the confidentiality of your account</li>
        <li>Use our services in compliance with applicable laws</li>
        <li>Not interfere with the proper working of our services</li>
      </ul>

      <h2>4. Intellectual Property</h2>
      <p>
        All content, features, and functionality of our services are owned by 
        Evoaxy Solutions and are protected by international copyright, trademark, 
        and other intellectual property laws.
      </p>

      <h2>5. Limitation of Liability</h2>
      <p>
        Evoaxy Solutions shall not be liable for any indirect, incidental, special, 
        consequential, or punitive damages resulting from your use of our services.
      </p>

      <h2>6. Termination</h2>
      <p>
        We reserve the right to terminate or suspend access to our services immediately, 
        without prior notice, for any reason whatsoever.
      </p>
    </LegalPage>
  )
}

